// app/features/industry-workflows/services_and_hooks/useIndustryWorkflowsHook.ts
import { useIndustryWorkflowByIdQueryHook,useIndustryWorkflowsQueryHook } from './useIndustryWorkflowsQueryHook';

/**
 * Unified hook for industry workflows list
 * Following "One Line to Rule Them All" pattern from blueprint
 */
export function useIndustryWorkflowsHook(filters?: {
  industry_id?: string;
  limit?: number;
  offset?: number;
  includeUnpublished?: boolean;
}) {
  const { workflows, total, isLoading, isError, error, refetch } = useIndustryWorkflowsQueryHook(filters);

  return {
    workflows,
    total,
    isLoading,
    isError,
    error,
    refetch,
  };
}

/**
 * Unified hook for single industry workflow
 * Following "One Line to Rule Them All" pattern from blueprint
 */
export function useIndustryWorkflowDetailHook(id: string) {
  const { workflow, isLoading, isError, error, refetch } = useIndustryWorkflowByIdQueryHook(id);

  const isGenerating = workflow && !['completed', 'failed'].includes(workflow.generation_status);

  return {
    workflow,
    isLoading,
    isError,
    error,
    isGenerating,
    refetch,
  };
}

